import React from 'react';
import { useDispatch } from 'react-redux';
import { filterDeliveryDonwload } from '../../actions/deliveryNotes';

import moment from 'moment';

export const BtnDeliveryOrders = (props) => {

    const dispatch = useDispatch();
    const date = moment().format("yyyy-MM-DD");;
    let dateWeek = moment();
    const intervalMovement = window.APP_CONFIG.daymovement;
    dateWeek = dateWeek.subtract(intervalMovement, "days");
    dateWeek = dateWeek.format("yyyy-MM-DD");

    const deliverynNotes = {
        store_id: props.store !== undefined ? props.store :'' ,
        sdate: dateWeek,
        edate: date,
        narticle: '',
        ean: '',
        sscc: '',
        ordercode: props.order,
        deliverynote: '',
        providercode: '',
    }

    const handleClick = () => {
        dispatch(filterDeliveryDonwload(deliverynNotes));
    }

    return (
        <button className="btn btn_link" props={props} onClick={handleClick}>
           { props.order }
        </button>
    )
}
